// Exports
export default {
	"container": "container_LMcCW",
	"underlay": "underlay_z1QQ-",
	"title": "title_zuZkb",
	"subtitle": "subtitle_w4+QH",
	"phoneImg": "phoneImg_c2fvf",
	"installAppButton": "installAppButton_FAdZ5",
	"openAppButton": "openAppButton_Kvk7M",
	"overBottomButton": "overBottomButton_dA57a",
	"oldContainer": "oldContainer_Mi9sp",
	"oldTitle": "oldTitle_IJwZ8",
	"oldSubtitle": "oldSubtitle_tqVvs",
	"oldInstallAppButton": "oldInstallAppButton_k4ZTb",
	"oldOpenAppButton": "oldOpenAppButton_jq9kg"
};
